module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAWBAMAAABeafMwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUxpcTIyMi8vLzExMi8vLzExMjExMjExMzExMjExMjAwMjAwMTExMx8MbfMAAAAMdFJOUwB/IN8Qz5/vj963ioI29WwAAACOSURBVHjabcyxCcIAFIThi4hJaWeTQnCD1Cls3MDSwgEcIEOkyhxZQkQxckOJ95R7EK97Px8Pf7fpZndFnnNakSjJR24XtYBmRMGAZgTGgGYv4EDy+Ws9ySOwPJFcq+jRfY+A12h1MEMzQ7MPbAXFbsGAnaBYg+8WgmJbIEMzQzNDM0OzDAdoGU5iGZq9AQ8ZavkZuWTiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/per1 (46).png
// module id = YGnt
// module chunks = 1